import { Component, OnInit, ViewChildren, QueryList, Input, Output, EventEmitter, ElementRef, ViewChild, OnDestroy, TemplateRef } from '@angular/core';
import { Observable, of, Subscription, BehaviorSubject, Subject } from 'rxjs';
import { ExtensionContext } from '../../extensions/extension-context';
import { EventService } from '../../../core/services/event.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { FiltrocampoComponent } from 'src/app/shared/ui/filtrocampo/filtrocampo.component';
import Swal from 'sweetalert2';
import { NgbAccordionDirective, NgbModal, NgbModalRef, NgbOffcanvas, NgbOffcanvasRef, NgbPagination, NgbPaginationPages } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MenuEvent } from 'src/app/core/services/menuevent.service';
import { DropzoneComponent } from '../dropzone/dropzone.component';
import { FiltrocanvasComponent } from '../filtrocanvas/filtrocanvas.component';
import { formatDate } from '@angular/common';
import { ReportesComponent } from '../reportes/reportes.component';
import { FiltrosPersistenciaService } from 'src/app/core/services/filtros-persistencia.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-advancedtable',
  templateUrl: './advancedtable.component.html',
  styleUrls: ['./advancedtable.component.scss'],
  providers: [],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateY(0)',
        opacity: 1,
        height: '*'
      })),
      state('out', style({
        transform: 'translateY(-10px)',
        opacity: 0,
        height: '0px',
        overflow: 'hidden'
      })),
      transition('in => out', [
        animate('300ms ease-in-out')
      ]),
      transition('out => in', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

/**
 * Advanced table component
 */
export class AdvancedtableComponent implements OnInit, OnDestroy {

  MostrarFiltroPrincipal: any
  CNT05COD: any;
  M05COD: any;
  CNT05DES: any;
  M05DES: any;
  // mospina 21-10-26 Breadcrumb compañía/sede
  get companiaActual(): string { return localStorage.getItem("X-AVATAR-CNT05DES") || ''; }
  get sedeActual(): string { return localStorage.getItem("X-AVATAR-M05DES") || ''; }
  Mostrartitulofiltro = false;
  toolbar: any;
  tableData2: Array<any> = [];
  tableData3: Array<any> = [];
  estructura: Observable<any>;
  llaves: Array<string> = [];
  ColumnasSN = [];
  reportes: Array<string> = [];
  filtrosReporte: Array<string> = [];
  form_template$: Observable<any>;;
  operaciones: any;
  ShowLoadingIndicator = true;
  currentPage: number  = 1;
  itemsPerPage: number = 10;
  number = [10, 20, 40, 60, 100];
  public height = '100vh';
  intSYS02CON: string;
  strEventListener: string;
  blnFiltrosAbiertos: boolean = false;
  blnFiltrosAbiertosHorizontal: boolean = false;
  tipo_pantalla: string = '';
  favorito_pantalla: string = '';
  ActivarFiltro: string = '';
  ActivarFavorito: string = '';
  permitir_click_lista: string = '';
  UrlClickLista: string = '';                // almora 2021.11.20 URL para el click en la lista por default
  WsMsDataInterno: string = '';              // almora 2021.11.28 Data Para el Mantenimiento Intero
  strWsURLModal: string = '';
  WsLlavesModal: string = '';
  WsSeleccionModal: string = '';
  mostrarbreitem: boolean = false;
  MostrarReportes: string = '';
  listaReportes = null;
  tipoReporte = null;
  respFiltros = [];
  blnAccionbuscar = 0;
  Select_grabar: any;
  SYS02TUT = '';
  SYS02TIP = '';
  SYS41ARC = [];
  INDEX: number;
  mostrarFiltrosAvanzados = false;

  @ViewChild('contenido') contenido: TemplateRef<any>;

  index: number = 0;
  currentPDF: any;
  TituloPantalla: string = "";
  suscription: Subscription = null;
  safeURL: SafeResourceUrl;
  formFiltros = null;
  filtrosAvanzados = null;
  filtro_guardado = [];
  filtroSel = null;
  AccionesOnChange = [];
  PAD10COD: any;
  TiempoBackend: number = 0;
  TiempoInicio = new Date();
  TiempoFinal = new Date();

  // almora 2026.05.09 — Solo aplicar filtros guardados una vez (en la primera carga real, no en refetchs)
  private _filtrosStorageAplicado: boolean = false;
  SYS02EXT: string[] = [];
  private _filtrosObligatorios$ = new BehaviorSubject<any[]>([]);
  private _filtrosOpcionales$   = new BehaviorSubject<any[]>([]);
  private _seleccion$           = new BehaviorSubject<any[]>([]);
  private _data$                = new BehaviorSubject<any[]>([]);
  private _reload$              = new Subject<void>();
  extensionContext: ExtensionContext = null;

  @Input() ToolbarSN: string[];
  @Input() breadCrumbItems: Array<{}>;
  @Input() WsURL: string = '';
  @Input() WsLlaves: any = '';
  @Input() WsSeleccion: any = '';
  @Input() WsFiltroModal: any = '';         // almora 2024.10.17 Filtro para Modal
  @Input() MsDetalle: string = 'N';         // almora 2021.11.21 Abrir en Detalle S/N, S cuando viene de NAVS, N por Default
  @Input() mostrarModal: boolean = false;
  @Input() A04CDE = null;
  @Input() WORKFLOW: any;                  // almora 2023.07.01 Información de Workflow
  @Input() DOC10ARC: any;                  // almora 2023.07.05 Información de Cejilla Documentos
  @Input() PRO10ARC: any;                  // almora 2024.01.31 Información de Cejilla Gantt Proyectos
  @Input() SYS02CON_PAPA_LD: string;       // almora 2024.06.19 Guardo SYS02CON de la tabla principal, se carga si soy Lista Detalle desde Wizard
  @Input() SYS02CON_PAPA_MODAL: any;      // almora 2024.10.25 Guardo SYS02CON del papá que me llamó, usado si soy modal para validar seguridad
  @Input() strSYS02TIP: string;

  @Output() RetornoModal = new EventEmitter();
  @Output() AbrirNuevoNav = new EventEmitter<string>();

  @ViewChildren('chkTabla') objChecks: QueryList<ElementRef>
  @ViewChild(FiltrocampoComponent) child: FiltrocampoComponent;
  @ViewChild(ReportesComponent) reportesComponent!: ReportesComponent;
  @ViewChild('acc') acc: NgbAccordionDirective;
  @ViewChild('paginateList') pag: NgbPagination;


  order_mostrar: boolean = false;
  modalRef: NgbModalRef;
  offcanvasRef: NgbOffcanvasRef = null;
  paginaInput: number = 1;
  paginaBase: number = 1;


  constructor(private dataService: SharedService,
    private eventService: EventService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private menuEvent: MenuEvent,
    private offcanvasService: NgbOffcanvas,
    private filtrosPersistencia: FiltrosPersistenciaService) {
    this.obtener_localstorage();
  }


  retornaObservable(form_template) {
    const obs$ = new Observable(observer => {
      observer.next(form_template);
    });
    return obs$;
  }

  open() {
    this.offcanvasRef = this.offcanvasService.open(FiltrocanvasComponent, { backdrop: true, position: 'end', scroll: true, backdropClass: 'bg-transparent', panelClass: 'scroll-canvas' });
    this.offcanvasRef.componentInstance.form_template = this.respFiltros;
    this.offcanvasRef.componentInstance.strListener = this.strEventListener;
    this.offcanvasRef.componentInstance.blnMostrarBusqueda = this.tipo_pantalla != 'REPORTE';
    this.offcanvasRef.componentInstance.TipoPantalla = this.tipo_pantalla;
    this.offcanvasRef.componentInstance.Mostrartitulofiltro = this.Mostrartitulofiltro;
    this.offcanvasRef.componentInstance.formFiltros = this.formFiltros;
    this.offcanvasRef.componentInstance.reportes = this.reportes;
    this.offcanvasRef.componentInstance.WsLlaves = this.WsLlaves;
    this.offcanvasRef.componentInstance.SYS02CON = this.intSYS02CON;
    this.offcanvasRef.componentInstance.estructura = this.estructura;
    this.offcanvasRef.componentInstance.filtrosAvanzados = this.child?.DemeFormulario();
    this.offcanvasRef.result.then((result) => {
      this.formFiltros = result;
      this.currentPage = 1;
      this.paginaInput = 1;
      this._fetchData(this.isObject(result) ? result : JSON.parse(result));
    }).catch(() => {

    });
    this.offcanvasRef.componentInstance.abrirNav.subscribe((json) => {
      this.AbrirNuevoNav.emit(json);
    });
  }

  ngOnInit() {
    this.obtener_localstorage();
    if (this.MostrarFiltroPrincipal == 'false') {
      this.blnFiltrosAbiertosHorizontal
    } else {
      this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal
    }
    this.Mostrartitulofiltro = true
    // almora 2026.05.25 — Aplicar filtros persistentes en el PRIMER fetch para evitar
    // el doble-llamado original (que iba sin filtros para descubrir FiltrosAvanzado y
    // luego repetia con filtros). El backend de ListarGenerico ignora los nombres
    // desconocidos en FILTROS_OPCIONALES, asi que es seguro adelantarlos. Si por
    // alguna razon no podemos extraer SYS02CON del URL aqui, el bloque post-response
    // mas abajo (gateado por _filtrosStorageAplicado) sigue como fallback.
    if (!this.mostrarModal && this.strSYS02TIP !== 'CAL') {
      const sys02 = this._extraerSYS02CONDeURL(this.WsURL);
      if (sys02) {
        const aplicables = this.filtrosPersistencia.getFiltrosIniciales(sys02);
        if (aplicables && Object.keys(aplicables).length > 0) {
          this.formFiltros = aplicables;
          this._filtrosStorageAplicado = true;
        }
      }
    }
    if (this.strSYS02TIP == 'CAL') {
      this._fetchData({}, -1);
    }else{
      this._fetchData(this.formFiltros);
    }
  }

  /**
   * Extrae el SYS02CON del WsURL. El identificador puede ser numerico
   * ('123') o alfanumerico ('lstMAM_Automatricula_Est', 'regMarcajes', etc.) —
   * tabs-manager.ts:496/577 confirma que abrirAccion pasa el SYS02CON tal cual
   * a la URL.
   *
   * Devolvemos null si el ultimo segmento coincide con el nombre del endpoint
   * (ListarGenerico/ShowDashboard/ShowGantt) — eso significa que no hay id
   * appended.
   */
  private _extraerSYS02CONDeURL(url: string): string | null {
    if (!url) return null;
    const segs = url.split('?')[0].split('/').filter(s => s.length > 0);
    if (segs.length < 2) return null;
    const last = segs[segs.length - 1];
    const endpoint = segs[segs.length - 2];
    if (last === endpoint || last === 'ListarGenerico' || last === 'ShowDashboard' || last === 'ShowGantt') return null;
    return /^[A-Za-z0-9_-]+$/.test(last) ? last : null;
  }

  cerrarmodal(event) {
    this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal;
    this.obtener_localstorage();
  }

  /**
   * fetches the table value
   */

  _fetchData(filtros?: any, paginador?, callback?: () => void, silencioso: boolean = false, reemplazar: boolean = false) {
    if (!silencioso) this.ShowLoadingIndicator = true;

    this.TiempoInicio = new Date();
    this.TiempoFinal = new Date();

    if (filtros == null) {
      filtros = JSON.parse('{}');
    }

    // mospina 2026.09.24 — Fusión con los globales persistidos.
    if (!this.mostrarModal && this.SYS02TIP != 'CAL' && this.intSYS02CON != null) {
      const globales = this.filtrosPersistencia.getFiltrosIniciales(this.intSYS02CON);
      if (globales != null && Object.keys(globales).length > 0) {
        filtros = { ...globales, ...filtros };   // lo digitado pisa al global
        this.formFiltros = filtros;
      }
    }

    if (this.WsLlaves == null || this.WsLlaves == "")
      this.WsLlaves = [];

    if (this.WsFiltroModal == null || this.WsFiltroModal == "")
      this.WsFiltroModal = [];
      if (paginador == null) {
        this.currentPage = 1;
        this.paginaInput = 1;
        this.paginaBase = 1;
      }

    let objFiltros = JSON.parse("{   \"FILTROS_OPCIONALES\"   : [" + JSON.stringify(this.formatearFormulario(filtros)) + "]" +
      (this.WORKFLOW != null ? (", \"WORKFLOW\" : " + JSON.stringify(this.WORKFLOW)) : "") +
      (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
      (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "") +
      (this.SYS02CON_PAPA_MODAL != null ? (", \"SYS02CON_PAPA_MODAL\" : " + JSON.stringify(this.SYS02CON_PAPA_MODAL)) : "") +
      ", \"FILTROS_MODAL\" : " + JSON.stringify(this.WsFiltroModal) +
      ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) +  
      ", \"PAGINA\" : " + (paginador == null ? this.currentPage : paginador)  +  
      ", \"OFFSET\" : " + this.itemsPerPage + 
      "}");

    this.dataService.ConsultarWS(this.WsURL, objFiltros).subscribe(
      (datosResp: any) => {
        // limpio todo
        
        this.permitir_click_lista = datosResp.PermitirClickLista;
        this.UrlClickLista = datosResp.UrlClickLista;     
        this.estructura = datosResp.Estructura;
        this.operaciones = datosResp.Operaciones;
        this.reportes = datosResp.Reportes;
        this.filtrosReporte = datosResp.Filtros
        this.toolbar = datosResp.Toolbar;
        this.tipo_pantalla = datosResp.Tipo;
        this.favorito_pantalla = datosResp.Favorito;
        this.ActivarFiltro = datosResp.ActivarFiltro;
        this.ActivarFavorito = datosResp.ActivarFavorito;
        this.intSYS02CON = datosResp.SYS02CON;
        this.TituloPantalla = datosResp.SYS02DES;
        this.MostrarReportes = datosResp.MostrarReportes;
        this.Select_grabar = datosResp.SYS20ARC;
        this.AccionesOnChange = datosResp.AccionesOnChange;
        this.strSYS02TIP = datosResp.SYS02TIP;
        this.SYS02TUT = datosResp.SYS02TUT;
        this.SYS02TIP = datosResp.SYS02TIP;
        this.SYS41ARC = datosResp.SYS41ARC;
        this.TiempoBackend = datosResp.TiempoBackend;

        if (this.suscription == null) {
          this.strEventListener = this.intSYS02CON;
          localStorage.removeItem("busqueda" + this.strEventListener);
          this.suscription = this.eventService.subscribe('EVENTO_REFRESAR_LISTA_' + this.strEventListener, (data) => {
            let busqueda = this.obtenerBusqueda(this.strEventListener);
            this.filtrosAvanzados = JSON.parse(busqueda);
            if (busqueda != null) {
              this.formFiltros = this.filtrosAvanzados;
              data = this.formFiltros;
              // almora 2026.05.15 — Persistir filtros aplicados desde el panel avanzado.
              // BuscarAvanzado() no pasa por onFilter(); el filtro se aplica por este evento.
              if (this.SYS02TIP === 'LST' && !this.mostrarModal && this.intSYS02CON) {
                this.filtrosPersistencia.guardarFiltrosFromForm(this.intSYS02CON, this.formFiltros);
              }
              if (this.acc != null) {
                this.acc.collapseAll();
              }
            } else {
              if (this.formFiltros != null) {
                data = this.formFiltros;
              }
            }
            this.currentPage = 1;
            this.paginaInput = 1;
            if (this.strSYS02TIP == 'CAL') {
              this._fetchData(this.isObject(data) ? data : JSON.parse(data), -1);
            }else{
              this._fetchData(this.isObject(data) ? data : JSON.parse(data));
            }
          });
        }

        if (paginador == null) {
          this.tableData2 = datosResp.DataTable || [];
        
          this.tableData3 = [];
          this.llaves = [];
          this.ColumnasSN = [];
          this.paginaBase = 1;
          this.currentPage = 1;
          this.paginaInput = 1;
          this.INDEX = this.tableData2.length - 1;
        
          for (let i = 0; i < datosResp.Estructura.length; i++) {
            if (datosResp.Estructura[i].A03PKY === "S") {
              this.llaves.push(datosResp.Estructura[i].A03COD);
            };

        
            if (datosResp.Estructura[i].A03VIS === "S") {
              this.ColumnasSN.push(datosResp.Estructura[i]);
            };
        
            if (datosResp.Estructura[i].A09AMF.length > 0 && datosResp.Estructura[i].A03PKY == 'N') {
              this.tableData3.push({ codigo: datosResp.Estructura[i].A03COD, des: datosResp.Estructura[i].A09AMF });
            };
          }
        
          if (datosResp.Operaciones !== undefined) {
            if (this.mostrarModal) {
              this.form_template$ = this.retornaObservable(datosResp.Filtros);
            } else {
              this.respFiltros = datosResp.Filtros;
            }
          }
        
          this.filtro_guardado = this.Select_grabar;
        }else{
          if(datosResp.DataTable.length > 0){
        
            if (this.strSYS02TIP == 'CAL') {
              this.llaves = [];
              this.ColumnasSN = [];
              this.tableData2 = [];
              this.tableData3 = [];
              for (let i = 0; i < datosResp.Estructura.length; i++) {
                if (datosResp.Estructura[i].A03PKY === "S") {
                  this.llaves.push(datosResp.Estructura[i].A03COD);
                };

                if (datosResp.Estructura[i].A03VIS === "S") {
                  this.ColumnasSN.push(datosResp.Estructura[i]);
                };

                if (datosResp.Estructura[i].A09AMF.length > 0 && datosResp.Estructura[i].A03PKY == 'N') {
                  this.tableData3.push({ codigo: datosResp.Estructura[i].A03COD, des: datosResp.Estructura[i].A09AMF });
                };
              }

              if (datosResp.Operaciones !== undefined) {
                this.respFiltros = datosResp.Filtros;
              }
            }
            if (reemplazar) {
              this.tableData2 = [];
              this.INDEX = -1;
              this.paginaBase = paginador;
            }
        
            for (const i in datosResp.DataTable) {
              datosResp.DataTable[i].INDEX = this.INDEX + 1;
              this.INDEX++;
              this.tableData2.push(datosResp.DataTable[i]);
            }
        
            this.currentPage = paginador;
            this.paginaInput = paginador;
          }else{
            this.paginaInput = this.currentPage;
            if(!silencioso && this.pag != null) {
              this.pag.selectPage(paginador-1);
            }
          }
        }  
        
        if (datosResp.Estructura.length != "" && datosResp.Estructura.length > 0) {
          this.ShowLoadingIndicator = false;
        } else {
          this.ShowLoadingIndicator = true;
        }
        
        for (let j = 0; j < this.tableData2.length; j++) {
          this.tableData2[j].checkado = false;
          for (let k = 0; k < this.tableData3.length; k++) {
            if (this.tableData2[j][(this.tableData3[k].codigo)] != undefined) {
              for (let w = 0; w < this.tableData3[k].des.length; w++) {
                if (this.tableData3[k].des[w].A09COD == this.tableData2[j][this.tableData3[k].codigo]) {
                  this.tableData2[j][this.tableData3[k].codigo] = this.tableData3[k].des[w].A09DES;
                }
              }
            }
          }
        } 

        this.formatearDecimales(datosResp.Estructura, this.tableData2);

        this.ShowLoadingIndicator = false;
        this.TiempoFinal = new Date();
        this.SYS02EXT[0] = datosResp.SYS02EXT;
        this._ensureExtensionContext();
        this._filtrosObligatorios$.next(this.WsLlaves || []);
        this._filtrosOpcionales$.next(this.formFiltros ? [this.formFiltros] : []);
        this._data$.next(this.tableData2);
        this._seleccion$.next([]);
        this._reload$.next();

        // almora 2026.05.09 — Aplicar filtros guardados (globales+particulares) en la PRIMERA carga
        // de pantallas SYS02TIP=LST que no son modal. Solo si el usuario no aplico filtros propios.
        if (!this._filtrosStorageAplicado
            && this.SYS02TIP === 'LST'
            && !this.mostrarModal
            && this.intSYS02CON
            && this.formFiltros == null) {
          this._filtrosStorageAplicado = true;
          const camposDisp: string[] = [];
          if (this.respFiltros && this.respFiltros[0] && this.respFiltros[0].FiltrosAvanzado) {
            for (const f of this.respFiltros[0].FiltrosAvanzado) {
              if (f && f.label) camposDisp.push(f.label);
            }
          }
          const aplicables = this.filtrosPersistencia.getAplicables(this.intSYS02CON, camposDisp);
          if (aplicables && Object.keys(aplicables).length > 0) {
            this.formFiltros = aplicables;
            this.currentPage = 1;
            this.paginaInput = 1;
            this._fetchData(this.formFiltros);
          }
        }

        if (!silencioso) this.ShowLoadingIndicator = false;
        this.mostrarFiltrosAvanzados = false;
        if (callback) callback();

        this.mostrarFiltrosAvanzados = false;
      },
      error => {
        Swal.fire({
          html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-8">' +
            '<h3>Error</h3><br>' +
            ' <p>' + error + '</p>' +
            ' </div> ',
        })
        localStorage.setItem(this.WsURL, "{}");
      }
    );
  }

  formatearDecimales(estructura: any[], data: any[]) {
    // 1. Tipo 'decimal'
    // 2. NO sean A03PKY !== 'S' (Primaria)
    // 3. SEAN de tipo SYS03TIP === 'N' (Número)
    const columnasDecimales = (estructura || [])
      .filter((col: any) => 
        col.A03TIP === 'decimal' && 
        col.A03PKY !== 'S' && 
        col.SYS03TIP === 'N'
      )
      .map((col: any) => col.A03COD);
  
    for (let fila of data) {
      for (let col of columnasDecimales) {
        const valor = fila[col];
  
        if (valor !== undefined && valor !== null && valor !== '') {
          // Se deja solo el numro
          const numero = Number(String(valor).replace(/,/g, ''));
          
          // Se valida que el valor no sea nulo o sin formato (por el tema de tipo)
          if (!isNaN(numero)) {
            fila[col] = new Intl.NumberFormat('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(numero);
          }
        }
      }
    }
  }

  AbrirURL(json) {
    if (this.MsDetalle == 'S') {
      // Abro un URL en mantenimiento interno
      this.WsMsDataInterno = json;
    } else {
      // Emito el evento para abrir un nuevo tab
      this.AbrirNuevoNav.emit(json);
    }
  }

  EventoClickToolbar(clicked, url, formato?, descripcion?) {
    const btn = document.getElementById(clicked.target.id) as HTMLButtonElement;
    if (clicked.target.id == 'INSERT') {
      if (this.mostrarModal) {
        // El evento es un insert para grabar datos desde una lista modal
        let arr: any[] = [];
        let blnExiste: boolean = false;
        this.objChecks.forEach((objCheck) => {
          if (objCheck.nativeElement.checked) {
            let index = objCheck.nativeElement.value;
            if (index != -1) {
              let llaves = this.DemeLlavesIndexJSON(index);
              arr.push(llaves);
            }
            blnExiste = true;
          };
        });

        if (blnExiste) {
          let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
            ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) +
            (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "");

          var jsonFiltros = this.toJSON(clicked.target.id, arr, null, null, arrLlaves);

          this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
            (datosResp: any) => {
              // Recargo los datos de la lista MODAL
              this._fetchData();
            },
            error => {
              Swal.fire({
                html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-4">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  '</div>' +
                  ' <div class="col-8">' +
                  '<h3>Error</h3><br>' +
                  ' <p>' + error + '</p>' +
                  ' </div> ',
              });
            }
          );
        } else {
          Swal.fire({
            html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              '</div>' +
              ' <div class="col-8">' +
              '<h3>Error</h3><br>' +
              ' <p>Debe seleccionar los registros con los que desea trabajar.</p>' +
              ' </div> ',
          });
        }

      } else {
        // El evento es insert para abrir un mantenimiento en blanco
        let arr: any[] = [];
        let llaves = {};
        arr.push(llaves);

        let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
          ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves) +
          (this.SYS02CON_PAPA_LD != null ? (", \"SYS02CON_PAPA_LD\" : " + JSON.stringify(this.SYS02CON_PAPA_LD)) : "");

        // Armo el JSON
        let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
        this.AbrirURL(json);
      }
      this.checktodos(false);
    } else if (clicked.target.id == 'WORKFLOW') {
      // almora 2023.07.01 Workflow
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
        ", \"WORKFLOW\"             : " + JSON.stringify(this.WORKFLOW) +
        ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves);

      // Armo el JSON
      let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
      this.AbrirURL(json);
    } else if (clicked.target.id == 'DOC10ARC' || clicked.target.id == 'PRO10ARC') {
      // almora 2023.07.05 Documentos
      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
        (this.DOC10ARC != null ? (", \"DOC10ARC\" : " + JSON.stringify(this.DOC10ARC)) : "") +
        (this.PRO10ARC != null ? (", \"PRO10ARC\" : " + JSON.stringify(this.PRO10ARC)) : "") +
        ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves);

      // Armo el JSON
      let json = this.toJSON(clicked.target.id, arr, url, null, arrLlaves);
      this.AbrirURL(json);
    } else if (clicked.target.id == 'INSERT_LISTA_SELECCION') {

      this.WsLlavesModal = this.WsLlaves;
      this.strWsURLModal = url;
      this.modalService.open(this.contenido, { size: 'xl' });

    } else if (clicked.target.id == 'INSERT_LISTA') {
      let urlModal = url.split("/");
      url = urlModal.slice(0, urlModal.length - 1).join("/");

      this.WsLlavesModal = this.WsLlaves;
      this.strWsURLModal = url;
      this.modalService.open(this.contenido, { size: 'xl' });

    } else if (clicked.target.id == 'SEND_INSERT_LISTA') {
      let urlModal = url.split("/");
      url = urlModal.slice(0, urlModal.length - 1).join("/");

      //Para seleccion ventana
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSONAux(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if(!blnExiste){
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
        return false;
      }

      this.WsLlavesModal = this.WsLlaves;
      this.WsSeleccionModal = JSON.stringify(arr);
      this.strWsURLModal = url;
      this.modalService.open(this.contenido, { size: 'xl' });

    } else if (clicked.target.id == 'EXPORTAR') {

      // El evento es Exportar
      let arr = { FILTROS_OBLIGATORIOS: [], FILTROS_OPCIONALES: [] };

      if (this.WsLlaves.length > 0) {
        arr.FILTROS_OBLIGATORIOS = this.WsLlaves;
      } else {
        arr.FILTROS_OBLIGATORIOS = [{}];
      }

      if (this.formFiltros != undefined) {
        let objForm = this.formatearFormulario(this.formFiltros);
        arr.FILTROS_OPCIONALES = [objForm];
      } else {
        arr.FILTROS_OPCIONALES = [{}];
      }

      let json = this.toJSON(clicked.target.id, arr, url);

      this.dataService.ConsultarWS(url, json, btn).subscribe(
        (datosResp: any) => {
          if (datosResp.Tipo == "ARCHIVO") {
            const blob = this.dataURItoBlob(datosResp.ARCHIVO_B64, 'XLS');
            let fileURL = URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.download = 'Exportar ' + this.TituloPantalla + '.xls';
            link.href = fileURL;
            link.click();
          }
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          });
        }
      );

    } else if (clicked.target.id == 'IMPRIMIR') {
      let parametros = url.split("/");
      let num = parametros.length;
      this.objChecks.forEach((objCheck) => {
        let arr: any[] = [];
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {

          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          if (formato != "NAV") {
            this.VerReporte(parametros[num - 3], parametros[num - 2], parametros[num - 1], formato, arr);
          } else {
            this.AbrirReportePDFNav(parametros[num - 3], parametros[num - 2], parametros[num - 1], parametros[num - 4], arr);
          }
        };
      });

    } else if (clicked.target.id == 'IMPRIMIR_PERSONAL') {
      let parametros = url.split("/");
      let num = parametros.length;
      this.objChecks.forEach((objCheck) => {
        let arr: any[] = [];
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {

          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);

          if (formato != "NAV") {
            this.VerReportePersonalizado(parametros[num - 3], parametros[num - 2], parametros[num - 1], formato, arr);
          } else {
            this.AbrirReportePDFNav(parametros[num - 3], parametros[num - 2], parametros[num - 1], parametros[num - 4], arr);
          }
        };
      });

    } else if (clicked.target.id == "ABRIR_MS") {
      let arr: any[] = [];
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);

        };
      });

      // Armo el JSON
      let json = this.toJSON("SELECT", arr, url);
      // Emito el evento para abrir un nuevo tab
      this.AbrirURL(json);
    } else if (clicked.target.id == "ABRIR_MS_MASIVO") {
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if (!blnExiste) {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }else{
        let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
          ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(arr);
        // Armo el JSON
        let json = this.toJSON("INSERT", arr, url, null, arrLlaves);
        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(json);
      }
    } else if (clicked.target.id == "SUBIR_XML") {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: 'xl' });
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        this.dataService.ConsultarWS("api/archivos/recibir", JSON.stringify(files), btn).subscribe(datos => {
        });
      });
    } else if (clicked.target.id == 'INSERT_OPERACIONES') {

      let arr: any[] = [];
      let llaves = {};
      arr.push(llaves);

      let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
        ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves);


      var jsonFiltros = this.toJSON(clicked.target.id, arr, null, null, arrLlaves);


      const btn = document.getElementById(clicked.target.id) as HTMLButtonElement
      var operacion = clicked.target.id;
      if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
      else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado"
      else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";
      this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
        (datosResp: any) => {
          this.currentPage = 1;
          this.paginaInput = 1;
          this._fetchData(this.formFiltros);

          //alertas
          Swal.fire({
            toast: true,
            position: 'bottom-end',
            icon: 'success',
            text: operacion + ' Correctamente',
            showConfirmButton: false,
            timer: 3000
          });
        },
        error => {
          Swal.fire({
            html: '<div class="row" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              '</div>' +
              ' <div class="col-8">' +
              '<h3>  Error</h3>' +
              ' <p> ' + error + ' </p>' +
              ' </div> ',
          });
        }
      );
    } else if (clicked.target.id == 'EJECUTAR_PROCESO') {
      let llaves = [this.reportesComponent?.filtroCampo.DemeFormulario()];
      if (llaves[0] == undefined) {
        // almora 2024.11.05 Ejecutar Proceso , envio las llaves de la cejilla wizard
        llaves = this.WsLlaves;
      }
      if (llaves[0] != 0) {
        var jsonFiltros = this.toJSON(clicked.target.id, llaves, null, null);
        const btn = document.getElementById(clicked.target.id) as HTMLButtonElement
        var operacion = clicked.target.id;
        operacion = "Operación realizada exitosamente.";
        this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
          (datosResp: any) => {

            // Se activa filtros acanzados para que recargue el listado (filtros activos)
            this.BuscarAvanzado();

            //alertas
            Swal.fire({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              text: operacion,
              showConfirmButton: false,
              timer: 3000
            });

            if (datosResp.NOTIFICACION) {
		        if (datosResp.NOTIFICACION != "") {
		          Swal.fire({
		            html:
		              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
		              '<div class="col-5">' +
		              ' <img src="assets/images/image-notifiacion.jpg"> </img>' +
		              "</div>" +
		              ' <div class="col-7">' +
		              "<h3>Advertencia</h3><br>" +
		              " <p>" +
		              datosResp.NOTIFICACION +
		              "</p>" +
		              " </div> ",
		          });
              }
            }
          },
          error => {
            Swal.fire({
              html: '<div class="row" style="width:100%; overflow:auto;"> ' +
                '<div class="col-4">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                '</div>' +
                ' <div class="col-8">' +
                '<h3>  Error</h3>' +
                ' <p> ' + error + ' </p>' +
                ' </div> ',
            });
          }

        );
      } else {
        Swal.fire("Error", "Debe diligenciar los campos requeridos", 'error');
      }
    } else if (clicked.target.id == 'CARGAR') {
      this.modalRef = this.modalService.open(DropzoneComponent, { size: 'xl' });
      this.modalRef.componentInstance.limite = 1;
      this.modalRef.componentInstance.retornaFiles.subscribe((files: any[]) => {
        if (files.length > 0) {
          let peticion = { LLAVES: this.obtenerLlaves(), ARCHIVOS: files };
          this.enviarPeticion(clicked.target.id, url, JSON.stringify(peticion));
        }
      });

    } else if (clicked.target.id === 'DESCARGAR') {
      // 1) Llaves del filtro (puede venir undefined)
      const llaveFiltro = this.reportesComponent?.filtroCampo?.DemeFormulario();
    
      // si no hay llaveFiltro, usa WsLlaves (fallback)
      const llavesBase = llaveFiltro !== undefined ? [llaveFiltro] : (this.WsLlaves ?? []);
    
      // 2) Llaves que ya se tenián por otro lado
      const llavesObtener = this.obtenerLlaves() ?? [];
    
      // 3) Unificar (y filtrar undefined/null/0 si aplica)
      const llavesUnificadas = [...llavesBase, ...llavesObtener]
        .flat() 
        .filter(v => v !== undefined && v !== null);
    
      // usar las mismas llaves unificadas para todo
      const jsonFiltros = this.toJSON(clicked.target.id, llavesUnificadas, null, null);
    
      const peticion = {
        LLAVES: llavesUnificadas,
        FILTROS: [
          {
            ...(this.child?.DemeFormulario() ?? {}),
            ...(this.reportesComponent?.filtroCampo?.DemeFormulario() ?? {})
          }
        ]
      };
    
      if (this.SYS02TIP === 'RPT' && peticion.FILTROS[0] == 0) {
        Swal.fire("Error", "Debe diligenciar los campos requeridos", 'error');
      } else {
        this.enviarPeticion(clicked.target.id, url, peticion, 'descarga');
      }
    } else if (clicked.target.id == 'ABRIR_GANTT') {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if (blnExiste) {
        let objetoJSON = {
          FILTROS_OPCIONALES: arr,
          FILTROS_OBLIGATORIOS: this.WsLlaves
        };

        let jsonString = JSON.stringify(objetoJSON);
        this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: 4, titulo: 'Gantt', SYS02TIP: 'GANTT', "JSONllavesMantenimiento": jsonString });
      } else {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }
    } else if (clicked.target.id == 'CHECKOUT') {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSONAux(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if (blnExiste) {
        let objetoJSON = {
          FILTROS_OPCIONALES: arr,
          FILTROS_OBLIGATORIOS: this.WsLlaves
        };

        let jsonString = JSON.stringify(objetoJSON);
        this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: 5, titulo: 'Procesar Pago', SYS02TIP: 'CHECKOUT', "JSONllavesMantenimiento": jsonString, SYS02CON_PAPA: this.intSYS02CON });
      } else {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }
    } else if (clicked.target.id == 'ABRIR_CRONOGRAMA') {
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if (blnExiste) {
        let json = this.toJSON("SELECT", arr, "api/mantenimientos/MantenimientoGenerico/lstPRO11ARC");
        this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: "lstPRO11ARC", titulo: "Cronograma", JSONllavesMantenimiento: json });
      } else {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }
    } else if (clicked.target.id == "MI_WORKFLOW") {
      let arr: any[] = [];
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          url = "api/mantenimientos/MantenimientoGenerico/" + llaves['SYS02CON'];

          // Armo el JSON
          let json = this.toJSON("SELECT", JSON.parse('[' + llaves['WKF10JSO'] + ']'), url);
          // Emito el evento para abrir un nuevo tab
          this.AbrirURL(json);
        };
      });
    } else if (clicked.target.id == "SELECT_GENERICO") {
      let SYS16URL = url.split('/');
      if(SYS16URL.length == 2){
        let params = {SYS02CON: SYS16URL[0], SYS02TIP: 'LST', titulo: descripcion};    
        this.menuEvent.broadcast('ABRIR_NUEVO_TAB', params);
      } else{
        Swal.fire("Error", "Error de vista seleccionada", 'error');
      }
    } else {
      // El evento requiere seleccionar los checks
      let arr: any[] = [];
      let blnExiste: boolean = false;
      this.objChecks.forEach((objCheck) => {
        if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {

          let index = objCheck.nativeElement.value;
          let llaves = this.DemeLlavesIndexJSON(index);
          arr.push(llaves);
          blnExiste = true;
        };
      });

      if (blnExiste) {
        let arrLlaves = `"DATOS_SELECCION": ${this.WsSeleccion == '' ? '[{}]' : this.WsSeleccion}, "FILTROS_OPCIONALES": [{}], "FILTROS_OBLIGATORIOS": ${JSON.stringify(this.WsLlaves)}`;

        var jsonFiltros = this.toJSON(clicked.target.id, arr, null, null, arrLlaves);
        var operacion = clicked.target.id;
        if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
        else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado"
        else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";

        if (clicked.target.id == "DELETE_GENERICO" || clicked.target.id == "DELETE_WS" || clicked.target.id == "ANULAR") {
          var mensaje = "Está seguro de Eliminar?"
          if (clicked.target.id == "ANULAR") mensaje = "Está seguro de anular?"

          Swal.fire({
            title: mensaje,
            text: "No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No, cancelar!',
            confirmButtonText: clicked.target.id == "ANULAR" ? 'Sí, anularlo' : 'Si, eliminarlo',
          }).then((result) => {
            if (result.isConfirmed) {
              this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
                (datosResp: any) => {
                  this.currentPage = 1;
                  this.paginaInput = 1;
                  this._fetchData(this.formFiltros);
                  //alertas
                  Swal.fire({
                    toast: true,
                    position: 'bottom-end',
                    icon: 'success',
                    text: operacion + ' Correctamente',
                    showConfirmButton: false,
                    timer: 3000
                  });
                },
                error => {
                  Swal.fire({
                    html: '<div class="row" style="width:100%; overflow:auto;"> ' +
                      '<div class="col-4">' +
                      ' <img src="assets/images/imageerror.png"> </img>' +
                      '</div>' +
                      ' <div class="col-8">' +
                      '<h3>  Error</h3>' +
                      ' <p> ' + error + ' </p>' +
                      ' </div> ',
                  });
                }
              );
            }
          })
        } else {
          this.enviarPeticion(operacion, url, jsonFiltros);
        }
      } else {
        Swal.fire("Error", "Debe seleccionar los registros con los que desea trabajar", 'error');
      }
    }
  }

  obtenerLlaves() {
    let arr = [];
    this.objChecks.forEach((objCheck) => {
      if (objCheck.nativeElement.checked && objCheck.nativeElement.value != -1) {
        let index = objCheck.nativeElement.value;
        let llaves = this.DemeLlavesIndexJSON(index);
        arr.push(llaves);
      };
    });

    return arr;
  }

  enviarPeticion(operacion, url, jsonFiltros, descarga?) {

    this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
      (datosResp: any) => {
        this.currentPage = 1;
        this.paginaInput = 1;
        this._fetchData(this.formFiltros);

        if (descarga == null) {
          //alertas
          Swal.fire({
            toast: true,
            position: 'bottom-end',
            icon: 'success',
            text: operacion + ' Correctamente',
            showConfirmButton: false,
            timer: 3000
          });
        } else {
          const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
          let fileURL = URL.createObjectURL(blob);
          if (datosResp.tipo == 'application/pdf') {
            window.open(fileURL, '_blank');
          } else {
            let link = document.createElement('a');
            if (datosResp.nombre != null) {
              link.download = datosResp.nombre;
            } else {
              let tipoPartes = datosResp.tipo.split('/');
              if (tipoPartes.length > 1) {
                link.download = 'documento.' + tipoPartes[1];
              } else {
                link.download = 'documento';
              }
            }
            link.href = fileURL;
            link.click();
          }
        }

        if (datosResp.NOTIFICACION != null) {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/image-notifiacion.jpg"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Advertencia</h3><br>" +
              " <p>" +
              datosResp.NOTIFICACION +
              "</p>" +
              " </div> ",
          });
        }
      },
      error => {
        Swal.fire({
          html: '<div class="row" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-8">' +
            '<h3>  Error</h3>' +
            ' <p> ' + error + ' </p>' +
            ' </div> ',
        });
      }
    );
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }
      if (Array.isArray(form[key])) {
        form[key] = "'" + form[key].join("','") + "'";
      }
      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }

      /**Cambio 26-09-2025 mospina */
      // Se realiza cambio para campos tipo fecha
      let elemento = this.getObtenerCodigoCampo(key);
      // almora 2026.05.25 Guarda defensiva: en el PRIMER _fetchData (cuando se
      // pre-aplican filtros persistentes) estructura aun esta vacia y elemento es null.
      if (elemento && elemento.A03TIP === "datetime" && form[key] != "") {
        // Se secciona la fecha para formato correcto dd-MM-yyyy
        let [day, month, year] = form[key].split('/');
        let dateValue = new Date(`${year}-${month}-${day}`);
        // se valida si la fecha es valida
        if (!isNaN(dateValue.getTime())) {
          // se da formato a la fecha dd-MM-yyyy (dd/MM/yyyy no se reconoce)
          form[key] = formatDate(`${year}-${month}-${day}`, 'dd/MM/yyyy', 'en');
        } else {
          console.error('Fecha no válida:', form[key]);
        }
      }

      // almora 2026.05.25 Idem: respFiltros aun no esta cargado en el primer fetch.
      if ((form[key] == "true" || form[key] == "false")
          && this.respFiltros && this.respFiltros[0] && this.respFiltros[0].FiltrosAvanzado) {
        for (const i in this.respFiltros[0].FiltrosAvanzado) {
          if (this.respFiltros[0].FiltrosAvanzado[i].label == key) {
            if (form[key] == "true") {
              form[key] = this.respFiltros[0].FiltrosAvanzado[i].CheckBoxTrue;
            } else if (form[key] == "false") {
              form[key] = this.respFiltros[0].FiltrosAvanzado[i].CheckBoxFalse;
            }
            break;
          }

        }
      }
    }
    return form;
  }

  getObtenerCodigoCampo(label) {
    for (const i in this.estructura) {
      if (this.estructura[i].A03COD == label) {
        return this.estructura[i];
      }
    }
    return null;
  }

  toJSON(operacion: string, arr: any, url?: string, titulo?: string, extra?: string) {
    let NavID = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
    return JSON.parse("{ \"LLAVES\"   :" + JSON.stringify(arr) +
      (url != null ? (", \"URL\"      :\"" + url + "\"") : "") +
      (titulo != null ? (", \"TITULO\"      :\"" + titulo + "\"") : "") +
      (extra != null ? ("," + extra) : "") +
      ", \"NAV_ID\"   : \"" + NavID + "\"" +
      ", \"OPERACION\": \"" + operacion + "\"}");
  }

  isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }

  EjecutarAccion(arr: any[], i: number, b, btn?, extras?, descarga?) {
    if (arr.length > 0) {
      var jsonFiltros = this.toJSON(this.operaciones[i].Evento, arr, null, null, extras);
      var operacion = this.operaciones[i].Evento;
      if (operacion == "INSERT_GENERICO") operacion = "Campo Insertado";
      else if (operacion == "UPDATE_GENERICO") operacion = "Campo Actualizado"
      else if (operacion == "DELETE_GENERICO") operacion = "Eliminado";

      this.dataService.ConsultarWS(this.operaciones[i].URL, jsonFiltros, btn).subscribe(
        (datosResp: any) => {
          if (b != false){
            this.currentPage = 1;
            this.paginaInput = 1;
            this._fetchData(this.formFiltros);
          }
          if (descarga == null) {
            //alertas
            Swal.fire({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              text: operacion + ' Correctamente',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
            let fileURL = URL.createObjectURL(blob);
            if (datosResp.tipo == 'application/pdf') {
              window.open(fileURL, '_blank');
            } else {
              let link = document.createElement('a');
              if (datosResp.nombre != null) {
                link.download = datosResp.nombre;
              } else {
                let tipoPartes = datosResp.tipo.split('/');
                if (tipoPartes.length > 1) {
                  link.download = 'documento.' + tipoPartes[1];
                } else {
                  link.download = 'documento';
                }
              }
              link.href = fileURL;
              link.click();
            }
          }
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          });
        }
      );
    } else {
      alert('Debe seleccionar los registros a eliminar');
    }
  }

  // almora 2021.10.31 EventoClickLista() se usa tanto para el click normal como para el click modal
  EventoClickLista(event, index) {
    if (this.mostrarModal) {
      let arr: any[] = [];
      let llaves = this.DemeLlavesIndexJSON(index);
      arr.push(llaves);
      this.RetornoModal.emit(arr);
    } else {
      if (this.permitir_click_lista == "S") {
        let arr: any[] = [];
        let llaves = this.DemeLlavesIndexJSON(index);
        for (const property in this.WsLlaves[0]) {
          if (llaves[property] == null) {
            llaves[property] = this.WsLlaves[0][property];
          } else {
            llaves[property + '_1'] = this.WsLlaves[0][property];
          }
        }
        arr.push(llaves);

        // Armo el JSON
        let json = this.toJSON("SELECT", arr, this.UrlClickLista);

        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(json);
      }
    }
  }

  // almora 2021.10.31 EventoClickOperacion(), se usa para el click en la lista de items del menú Operacion
  EventoClickOperacion(operacion: any, index, i?) {
    const btn = document.getElementById(index) as HTMLButtonElement;
    if (operacion.URL != undefined) {
      let arr: any[] = [];
      let llaves = this.DemeLlavesIndexJSON(index);
      if (operacion.Evento == "UPDATE_GENERICO" && this.permitir_click_lista == "S") {
        arr.push(llaves);

        var jsonFiltros = this.toJSON("SELECT", arr, operacion.URL);

        // Emito el evento para abrir un nuevo tab
        this.AbrirURL(jsonFiltros);
      } else if (operacion.Evento == "EDITAR_LINEA") {
        let inputs = document.getElementsByClassName(index);
        for (const key in inputs) {
          if (inputs[key].id != undefined) {
            let attr = inputs[key].id.split("+");
            llaves[attr[0]] = (<HTMLInputElement>document.getElementById(inputs[key].id)).value;
          }
        }
        arr.push(llaves);
        this.EjecutarAccion(arr, i, false, btn);

        document.getElementById(index).style.display = 'none';
      } else if (operacion.Evento == "IMPRIMIR") {
        arr.push(llaves);
        let parametros = operacion.URL.split("/");
        let num = parametros.length;
        this.VerReporte(parametros[num - 3], parametros[num - 2], parametros[num - 1], "PDF", arr);
      } else if (operacion.Evento == "ABRIR_MS") {
        arr.push(llaves);

        // Armo el JSON
        let json = this.toJSON("SELECT", arr, operacion.URL);

        this.AbrirURL(json);
      }
      else if (operacion.Evento == "DELETE_WS" || operacion.Evento == "DELETE_GENERICO" || operacion.Evento == "ANULAR") {
        var mensaje = "Está seguro de Eliminar?"
        if (operacion.Evento == "ANULAR") mensaje = "Está seguro de anular?"

        Swal.fire({
          title: mensaje,
          text: "No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'No, cancelar!',
          confirmButtonText: operacion.Evento == "ANULAR" ? 'Si, anularlo' : 'Si, eliminarlo',
        }).then((result) => {
          if (result.isConfirmed) {
            arr.push(llaves);

            this.EjecutarAccion(arr, i, true, btn);
          }
        })
      } else if (operacion.Evento == "INSERT") {
        arr.push(llaves);

        let arrLlaves = "  \"FILTROS_OPCIONALES\"   : [{}]" +
          ", \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(this.WsLlaves);

        this.EjecutarAccion(arr, i, true, btn, arrLlaves);
      } else if (operacion.Evento == "DESCARGAR") {
        arr.push(llaves);
        this.EjecutarAccion(arr, i, true, btn, null, 'descarga');
      } else if (operacion.Evento == "MI_WORKFLOW") {
        let url = "api/mantenimientos/MantenimientoGenerico/" + llaves['SYS02CON'];
        let json = this.toJSON("SELECT", JSON.parse('[' + llaves['WKF10JSO'] + ']'), url);
        this.AbrirURL(json);
      } else {
        arr.push(llaves);

        this.EjecutarAccion(arr, i, true, btn);
      }
    }

  }

  DemeLlaves(data) {
    let arr: Array<string[]> = [];
    for (let i = 0; i < this.llaves.length; i++) {
      let llave = this.llaves[i];
      let valor = data[llave];

      let x: string[] = [llave, valor];
      arr.push(x);
    }
    return arr;
  }

  DemeLlavesIndexJSON(index) {
    let row = null;

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        row = this.tableData2[key];
        break;
      }
    }
    var arr = {};
    for (let i = 0; i < this.llaves.length; i++) {
      let llave = this.llaves[i];

      let encontro = false;
      let valor = "";
      for (let j = 0; j < this.tableData3.length; j++) {
        if (llave == this.tableData3[j].codigo) {
          valor = this.tableData3[j].des.find(element => element.A09DES == row[llave]);
          valor = valor["A09COD"];
          encontro = true;
          break;
        }
      }
      if (encontro == false && row != null) {
        valor = row[llave];

      }
      arr[llave] = valor;
    }

    return arr;
  }

  DemeLlavesIndexJSONAux(index) {
    let arr = {};

    for (const key in this.tableData2) {
      if (this.tableData2[key].INDEX == index) {
        const row = this.tableData2[key];
        arr[key] = row;
        break;
      }
    }

    return arr;
  }

  pageChange(page: number) {
    this.paginaInput = page;
    if (page > this.currentPage){
      if(this.tableData2.length <= this.itemsPerPage * (page - this.paginaBase)) {
        this._fetchData(this.formFiltros, page);
      }else{
        this.currentPage = page;
      }
    } else if (page < this.paginaBase) {
      this._fetchData(this.formFiltros, page, null, true, true);
    }else{
      this.currentPage = page;
    }
  }

  countNumber(event: any) {
    this.itemsPerPage = event;
    this.currentPage = 1;
    this.paginaInput = 1;
    this._fetchData(this.formFiltros);
  }

  dataURItoBlob(dataURI, strFORMATO, strType = "application/pdf") {
    if (strFORMATO == "XLS") strType = "application/vnd.ms-excel";
    if (strFORMATO == "SQL") strType = "application/octet-stream";
    if (strFORMATO == "TXT") strType = "text/plain";
    if (strFORMATO == "XML") strType = "application/xml";
    if (strFORMATO == "ZIP") strType = "application/zip";

    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  VerReporte(intSYS02CON: string, intSYS10CON: string, intTSTAMP: string, strFORMATO: string, llaves?) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    let opcionales = " \"FILTROS_OPCIONALES\" : [";
    if (this.formFiltros != null) {
      opcionales = opcionales + JSON.stringify(this.formFiltros) + "]";
    } else {
      opcionales = opcionales + "]";
    }
    let strjson = "{" + opcionales +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS10CON\"   : " + intSYS10CON +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TSTAMP\"     : " + intTSTAMP +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(llaves) + "}";

    let arr = JSON.parse(strjson);
    let json = this.toJSON('ABRIR_REPORTE_PDF', arr, 'api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, "");

    this.dataService.ConsultarWS('api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, json).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        this.tipoReporte = null;
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'warning',
        })
      }
    );
  }

  VerReportePersonalizado(intSYS02CON: string, intSYS44COD: string, intTSTAMP: string, strFORMATO: string, llaves?) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }

    let opcionales = " \"FILTROS_OPCIONALES\" : [";
    if (this.formFiltros != null) {
      opcionales = opcionales + JSON.stringify(this.formFiltros) + "]";
    } else {
      opcionales = opcionales + "]";
    }
    let strjson = "{" + opcionales +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS44COD\"   : \"" + llaves[0].SYS44COD + "\" " +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TSTAMP\"     : " + intTSTAMP +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_DASHBOARD\"    : [] " +
      " , \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(llaves) + "}";
    let arr = JSON.parse(strjson);

    let json = this.toJSON('ABRIR_REPORTE_PDF', arr, 'api/mantenimientos/VerReportePersonalizado/' + intSYS02CON + '/' + llaves[0].SYS44COD, "");

    this.dataService.ConsultarWS('api/mantenimientos/VerReportePersonalizado/' + intSYS02CON + '/' + llaves[0].SYS44COD, json).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        this.tipoReporte = null;
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'warning',
        })
      }
    );
  }



  // AbrirReportePDFNav
  // Método para abrir un PDF en una cejilla
  AbrirReportePDFNav(intSYS02CON: string, intSYS10CON: string, intTSTAMP: string, strSYS10DES: string, llaves?) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    let arr = JSON.parse("{    \"FILTROS_OPCIONALES\"   : [" + JSON.stringify(this.formFiltros) + "]" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS10CON\"   : " + intSYS10CON +
      " , \"FORMATO\"    : \"PDF\" " +
      " , \"TSTAMP\"     : " + intTSTAMP +
      " , \"TITULO\"     : \"" + strSYS10DES + "\"" +
      " , \"FILTROS_OBLIGATORIOS\" : " + JSON.stringify(llaves) + "}");

    // Armo el JSON
    let json = this.toJSON('ABRIR_REPORTE_PDF', arr, 'api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, strSYS10DES);
    this.AbrirNuevoNav.emit(json);
  }

  // AbrirReporteComponentePDFNav
  // Este metodo abre el reporte cuando se llama desde app-reportes
  AbrirReporteComponentePDFNav(json) {
    this.AbrirNuevoNav.emit(json);
  }

  RetornoModalLista(event) {
    // Este metodo se llama en el Cerrar de la Lista Modal
    this._fetchData(this.formFiltros);
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.currentPDF);
  }

  ordenasc(val) {
    this.tableData2.sort((a, b) => a[val] - b[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return -1;
        }
        return 0;

      }
    })
    this.order_mostrar = false;
  }

  ordendes(val) {
    this.tableData2.sort((a, b) => b[val] - a[val]);
    this.tableData2.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    })
    this.order_mostrar = true;
  }

  private _ensureExtensionContext() {
    if (this.extensionContext != null) return;
    if (!this.intSYS02CON) return;
    this.extensionContext = {
      SYS02CON: this.intSYS02CON,
      SYS02EXT: this.SYS02EXT[0],
      NAV_ID: this.intSYS02CON + '-' + Date.now() + '-' + Math.floor(Math.random() * 1e6),
      filtrosObligatorios$: this._filtrosObligatorios$.asObservable(),
      filtrosOpcionales$:   this._filtrosOpcionales$.asObservable(),
      seleccion$:           this._seleccion$.asObservable(),
      data$:                this._data$.asObservable(),
      reload$:              this._reload$.asObservable()
    };
  }

  _onSelectionChange() {
    const filas = (this.tableData2 || []).filter(r => r && r.checkado === true);
    this._seleccion$.next(filas);
  }

  // limpio
  // almora 2021.11.06 Se ejecuta OK
  ngOnDestroy(): void {
    if (this.mostrarModal) {
      this.RetornoModal.emit(JSON.parse('{  }'));
    }
    this.form_template$ = of([]);
    this.estructura = of([]);

    this._filtrosObligatorios$.complete();
    this._filtrosOpcionales$.complete();
    this._seleccion$.complete();
    this._data$.complete();
    this._reload$.complete();

    if (this.suscription != null)
      this.suscription.unsubscribe();
    this.llaves = [];
    this.ColumnasSN = [];
    this.reportes = [];
  }

  EventoCerrarMSInterno(objRefrescar: any) {
    this.WsMsDataInterno = '';
    this.currentPage = 1;
    this.paginaInput = 1;
    if (typeof objRefrescar === 'boolean') {
      if (objRefrescar) this._fetchData();
    } else if (typeof objRefrescar === 'object') {
      if (objRefrescar.WKF10COD)
        this.WORKFLOW[0].WKF10COD = objRefrescar.WKF10COD;
      if (objRefrescar.DOC10COD)
        this.DOC10ARC[0].DOC10COD = objRefrescar.DOC10COD;
      if (objRefrescar.PRO10COD)
        this.PRO10ARC[0].PRO10COD = objRefrescar.PRO10COD;
      this._fetchData();
    }
  }

  GrabarFavorito() {
    if (this.favorito_pantalla == "N") {
      this.EventoWsInsert();
    } else {
      this.EventoWsDelete();
    }
  }

  EventoWsInsert() {
    this.dataService.ConsultarWS('api/mantenimientos/Favoritos/ADD/' + this.intSYS02CON).subscribe(
      (datosResp: any) => {
        // almora 202.03.21 No necesito recargar la página
        this.favorito_pantalla = "S";
        Swal.fire({
          position: 'bottom-end',
          toast: true,
          icon: 'success',
          text: 'Dato Grabado exitosamente',
          showConfirmButton: false,
          timer: 5000
        });
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      });
  }

  EventoWsDelete() {
    this.dataService.ConsultarWS('api/mantenimientos/Favoritos/DEL/' + this.intSYS02CON).subscribe(
      (datosResp: any) => {
        // almora 202.03.21 No necesito recargar la página
        this.favorito_pantalla = "N";
        Swal.fire({
          position: 'bottom-end',
          toast: true,
          icon: 'success',
          text: 'Dato Eliminado exitosamente',
          showConfirmButton: false,
          timer: 5000
        });
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      });

  }

  EventoClickBuscar(col, btn) {
    this.blnFiltrosAbiertos = !this.blnFiltrosAbiertos;
    this.Mostrartitulofiltro = true
  }

  EventoClickBuscarHt(col, btn) {
    this.blnFiltrosAbiertosHorizontal = !this.blnFiltrosAbiertosHorizontal
    this.Mostrartitulofiltro = true
  }

  Mostrarboton(index) {
    let boton = document.getElementById(index);
    boton.style.display = "block";

  }

  obtener_localstorage() {
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.M05COD = localStorage.getItem("X-AVATAR-M05COD");
    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");
    this.MostrarFiltroPrincipal = localStorage.getItem("X-AVATAR-MOSTRARFILTRO");
    this.PAD10COD = localStorage.getItem("usuario");// mospina 2024.05.15 se obitne el código de usuario

    if (this.CNT05COD == "" || this.CNT05COD == undefined || this.M05COD == "" || this.M05COD == undefined) {
      Swal.fire({
        title: 'Error',
        text: "Por favor Seleccione una Compañia y Sede",
        icon: 'error',
      });
      this.menuEvent.abrirmodalcompaniaysede("");
      this.mostrarbreitem = true;
    } else {
      this.mostrarbreitem = false;
    }
  }

  isNumber(numero: string) {
    let diferente = Number(numero);
    if (isNaN(diferente)) {
      return false;
    } else {
      if (diferente > 1900 && diferente < 2100) {
        return false;
      }
      return true;
    }
  }

  checktodos(event) {
    let bandera = false;
    if (event.target) {               // almora 2023.04.13 Fix
      if (event.target.checked) {
        bandera = true;
      }
    }
    for (let index = 0; index < this.tableData2.length; index++) {
      this.tableData2[index].checkado = bandera;
    }
    this._onSelectionChange();
  }

  obtenerBusqueda(strListener) {
    let filtro = localStorage.getItem("busqueda" + strListener);

    if (filtro != null) {
      return filtro;
    } else {
      return null;
    }
  }

  GuardarFiltro() {
    if (this.formFiltros != null) {
      Swal.fire({
        title: 'Nombre del Filtro',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          let objForm = this.formatearFormulario(this.formFiltros);
          let strjson = {
            SYS20FIL: objForm,
            SYS20COD: "",
            SYS20DES: result.value,
            SYS02CON: this.intSYS02CON
          };
          let strjson2 = [strjson];
          let url = "api/filtros/Grabar/ADD/" + this.intSYS02CON;
          // Armo el JSON
          let json = this.toJSON("ADD", strjson2, url);
          this.dataService.ConsultarWS(url, json).subscribe(
            (datosResp: any) => {
              this.Select_grabar
              Swal.fire({
                position: 'bottom-end',
                toast: true,
                icon: 'success',
                text: 'Dato Grabado exitosamente',
                showConfirmButton: false,
                timer: 5000
              });
            },
            error => {
              Swal.fire({
                title: 'Error',
                text: error,
                icon: 'error',
              });
            }
          );
        }

      });
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Debe aplicar un filtro primero',
        icon: 'error',
      });
    }
  }

  DELETE_FILTRO() {
    if (this.filtroSel != null) {
      let strjson = [{
        SYS20FIL: {},
        SYS20COD: this.filtroSel.SYS20COD,
        SYS20DES: "",
        SYS02CON: this.intSYS02CON
      }];

      let url = "api/filtros/Grabar/DEL/" + this.intSYS02CON;
      let json = this.toJSON("DEL", strjson, url);
      this.dataService.ConsultarWS(url, json).subscribe(
        (datosResp: any) => {
          this.filtroSel = null;
          this.filtro_guardado = datosResp.DATA;
          this.Select_grabar;
          Swal.fire({
            position: 'bottom-end',
            toast: true,
            icon: 'success',
            text: 'Dato Eliminado exitosamente',
            showConfirmButton: false,
            timer: 5000
          });
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          });
        }
      );
    }
  }

  onFilter(event) {
    if (event != null) {
      this.formFiltros = event.SYS20FIL;
      this.formFiltros = this.formatearFormulario(this.formFiltros);
      this.currentPage = 1;
      this.paginaInput = 1;
      this._fetchData(this.formFiltros);
      // almora 2026.05.09 — Persistir filtros aplicados (solo en LST principal, no modales)
      if (this.SYS02TIP === 'LST' && !this.mostrarModal && this.intSYS02CON) {
        this.filtrosPersistencia.guardarFiltrosFromForm(this.intSYS02CON, this.formFiltros);
      }
    } else {
      this.formFiltros = null;
    }
  }

  limpiarbusqueda() {
    this.formFiltros = null;
    localStorage.removeItem("filtro" + this.intSYS02CON);
    localStorage.removeItem("busqueda" + this.intSYS02CON);
  
    // almora 2026.05.09 — Limpia particulares de esta pantalla. Globales se mantienen.
    if (this.SYS02TIP === 'LST' && !this.mostrarModal && this.intSYS02CON) {
      this.filtrosPersistencia.limpiarParticulares(this.intSYS02CON);
    }
    this.child?.myFormGroup.reset();
    let limpiar = {};

    // mospina 2026.09.11 EPT-2374 Se vuelven a aplicar los filtros guardados (globales)
    if (!this.mostrarModal && this.SYS02TIP != 'CAL' && this.intSYS02CON != null) {

      // Persisten solo los globales.
      const filtrosGuardados = this.filtrosPersistencia.getFiltrosIniciales(this.intSYS02CON);

      // Solo si hay filtros guardados se vuelven a aplicar
      if (filtrosGuardados != null && Object.keys(filtrosGuardados).length > 0) {

        limpiar = filtrosGuardados;           
        this.formFiltros = filtrosGuardados;  
        this._filtrosStorageAplicado = true;  
      }
    }

    this.currentPage = 1;
    this.paginaInput = 1; 
    if (this.SYS02TIP == 'CAL') {
      this._fetchData(limpiar, -1);
    }else{
      this._fetchData(limpiar);
    }
  
    this.objChecks.forEach((objCheck) => {
      if (objCheck.nativeElement.checked) {
        let index = objCheck.nativeElement.value;
        if (index == -1) {
          objCheck.nativeElement.checked = false;
        }
      };
    });
    if (this.acc != null) {
      this.acc.collapseAll();
    }
  }

  BuscarAvanzado() {
    this.currentPage = 1;
    this.paginaInput = 1;
    if (this.respFiltros[0].FiltrosAvanzado.length > 0) {
      this.blnAccionbuscar++;      
    } else {
      if (this.formFiltros != null) {
        if (this.SYS02TIP == 'CAL') {
          this._fetchData(this.formFiltros, -1);
        }else{
          this._fetchData(this.formFiltros);
        }
      } else {
        if (this.SYS02TIP == 'CAL') {
          this._fetchData({}, -1);
        }else{
          this._fetchData();
        }
      }
    }
    if (this.acc != null) {
      this.acc.collapseAll();
    }
  }

  abrirAyuda() {

    // mospina 15-04-2026 se obtiene localstorage campo 
    let CLITUT = localStorage.getItem('CLITUT');

    if (this.SYS02TUT != null && this.SYS02TUT != '') {
      window.open(this.SYS02TUT + "?c=" + CLITUT, '_blank');
    }
  }

  DiferenciaTiempo() {
    return (this.TiempoFinal.getTime() - this.TiempoInicio.getTime()) / 1000.0;
  } 

  recargarDesdeExtension(event){
    if (this.formFiltros != null) {
      if (this.SYS02TIP == 'CAL') {
        this._fetchData(this.formFiltros, -1);
      }else{
        this._fetchData(this.formFiltros);
      }
    } 
  }

  toggleFiltrosAvanzados() {
    this.mostrarFiltrosAvanzados = !this.mostrarFiltrosAvanzados;
  }

  irAPagina() {
    let destino = Number(this.paginaInput);
    if (!destino || destino < 1) destino = 1;
    destino = Math.floor(destino);
    this.paginaInput = destino;
    this.ShowLoadingIndicator = true;
  
    this._fetchData(this.formFiltros, destino, () => {
      this.ShowLoadingIndicator = false;
    }, true, true);
  }

  private _avanzarHastaPagina(destino: number) {
    const paginasCargadas = Math.max(
      1,
      Math.ceil(this.tableData2.length / this.itemsPerPage)
    );

    if (destino <= paginasCargadas) {
      this.currentPage = destino;
      this.paginaInput = destino;
      this.ShowLoadingIndicator = false;
      return;
    }

    const siguiente = paginasCargadas + 1;
    const totalAntes = this.tableData2.length;

    this._fetchData(
      this.formFiltros,
      siguiente,
      () => {
        const totalDespues = this.tableData2.length;

        if (totalDespues <= totalAntes) {
          const ultimaPagina = Math.max(
            1,
            Math.ceil(totalAntes / this.itemsPerPage)
          );

          this.currentPage = ultimaPagina;
          this.paginaInput = ultimaPagina;
          this.ShowLoadingIndicator = false;
          return;
        }

        this._avanzarHastaPagina(destino);
      },
      true
    );
  }
}
